import {
  ProductSelectionWidget,
  BoothSelectionWidget,
  ShopSelectionWidget,
  ProductUnitSelectionWidget,
} from 'components/FormWidget';

const uiSchema = () => ({
  product_id: {
    'ui:widget': ProductSelectionWidget,
    'ui:options': {
      initFilter: {
        for_admin: 1,
      },
    },
  },
  shop_id: {
    'ui:widget': ShopSelectionWidget,
    'ui:options': {
      initFilter: {
        for_admin: 1,
      },
    },
  },
  booth_id: {
    'ui:widget': BoothSelectionWidget,
  },
  unit_fie_id: {
    'ui:widget': ProductUnitSelectionWidget,
  },
  details: {
    'ui:widget': 'textarea',
  },
});

export default uiSchema;
